import AxiosControl from '../components/axios/AxiosControl'
import { getErrorMessage, getResponseData, getResponseMessage, isSuccessResponse } from '../helpers/apiResponse'
const Axios = AxiosControl()

export const getProductStates = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_STATE_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/product-state/getAll', {page, limit, search}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'PRODUCT_STATE_GETALL_SUCCESS',
                payload: getResponseData(data)
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_STATE_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const addProductState = (statedata) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_STATE_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/product-state/create', statedata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'PRODUCT_STATE_ADD_SUCCESS',
                payload: {
                    ...getResponseData(data),
                    message: getResponseMessage(data)
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_STATE_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const editProductState = (stateId, statedata) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_STATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/product-state/edit/'+ stateId, statedata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'PRODUCT_STATE_EDIT_SUCCESS',
                payload: {
                    ...getResponseData(data),
                    message: getResponseMessage(data)
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_STATE_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const resetProductStateResult = () => (dispatch) => {
    dispatch({
        type: 'PRODUCT_STATE_RESET_RESULT'
    })
}
